import axios from 'axios'
import store from '@/store/index'
import Router from '@/router/index.js'
import { getCookie ,isiOS, isAndroid } from '@/utils/index.js'
import Bridge from '@/utils/bridge.js'
import Vue from 'vue'

const isPro = process.env.NODE_ENV !== 'development'
// const isPro = true
const VUE_APP_BASE_API = process.env.VUE_APP_BASE_API
const REQUEST_API = process.env.REQUEST_API
const PUBLIC_KEY = process.env.PUBLIC_KEY
// create an axios instance
const service = axios.create({
  baseURL: VUE_APP_BASE_API + REQUEST_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000, // request timeout
})
//login
service.interceptors.request.use(
	config => {
		const appInfo_string = localStorage.getItem('appInfo')
    const appInfo = appInfo_string ? JSON.parse(appInfo_string) : {}
		if (config.headers) {
			config.headers['X-AppVersion'] = appInfo.xAppVersion
			config.headers['X-Channel'] = appInfo.xChannel
			config.headers['X-AppName'] = appInfo.xAppName
			config.headers['Accept-Language'] = appInfo.xAcceptLanguage
      config.headers['X-RequestIsFromH5'] = 'true'
		}
    const TOKEN = getCookie('token')
    if (TOKEN) {
			config.headers['X-Token'] = TOKEN
    }

		return config
	},
	error => {
		return Promise.reject(error)
	}
)
// aes
service.interceptors.request.use(
  config => {
    if (isPro) {
      if (!window.CECryptojs) {
        console.error('[Request] CECryptojs SDK not loaded! Encryption will be skipped. Check /static/sdk/CEC.js script path.')
      }
      try {
        const { aesKey, data } = window.CECryptojs.RSAWithAES.encrypt(
          PUBLIC_KEY,
          JSON.stringify(config.data || {}),
          'AES-CBC'
        );
        config._aesKey_ = aesKey
        config.data = {
          cryptogram: data.ciphertext,
          random: data.nonce,
          keyInfo: data.key,
          algorithm: data.algorithm
        }
      } catch (error) {
        console.error('[Request] Encryption failed:', error)
      }
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (isPro) {
      try {
        const aesKey = response.config._aesKey_ || '';
        const { cryptogram, random } = response.data || {};
        response.data = JSON.parse(
          window.CECryptojs.AES.decrypt(aesKey, random , cryptogram, 'AES-CBC')
        )
      } catch (error) {
        console.error(error)
        response.data = {
          success: false,
          statusString: '9999',
          msgString: 'Decryption failed'
        }
        return response.data
      }
    }
    console.log('response', response.data)
    if (response.data.statusString === '0001') {
      // 仅在 App WebView 内才走桥连接通知原生处理
      // 短链还款在 PC/手机浏览器中使用，一律走路由跳转
      // 注意：isAndroid() 只检测 UA 中的 "Android" 字样，普通安卓手机浏览器也会命中，
      //       因此再叠加 window.WebViewJavascriptBridge 存在性判断，确保只在 App 内才走桥
      var inAppWebView = isiOS() || (isAndroid() && window.WebViewJavascriptBridge)
      if (inAppWebView) {
        Bridge('loginAndCloseCurrentActivity', null, (res) => {
          console.log('loginAndCloseCurrentActivity', res)
          if (!res) {
            // App 未处理时兜底跳转登录页，避免卡死
            Router.push(`/login?redirect=${Router.currentRoute.fullPath}`)
          }
        })
      } else {
        // 浏览器环境（PC/手机）直接路由跳转登录页
        Router.push(`/login?redirect=${Router.currentRoute.fullPath}`)
      }
    }
    return response.data;
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js